export class PaymentAddress {
  id: number;
  billingAddressTypeId?: number;
  addressline1: string;
  addressline2: string;
  city: string;
  zip: string;
  country: string;
  state: string;
  name: string;

  constructor() {
    this.name = '';
  }
}
